import format from 'date-fns/format';
import en from 'date-fns/locale/en';
import de from 'date-fns/locale/de';
import fr from 'date-fns/locale/fr';
import { DOCUMENT_ELEMENT } from '@/scripts/constants';

/**
 * function to calculate local time
 * in a different city
 * given the city's UTC offset
 */
function calcDate(offset) {
  // create Date object for current location
  const d = new Date();

  // convert to msec
  // add local time zone offset
  // get UTC time in msec
  const utc = d.getTime() + (d.getTimezoneOffset() * 60000);

  // create new Date object for different city
  // using supplied offset
  return new Date(utc + (3600000 * offset));
}

export function showDate(dateElement) {
  if (!dateElement) return;
  const locales = { en, de, fr };
  const { lang } = DOCUMENT_ELEMENT;
  const { utcOffset } = dateElement.dataset;
  const date = calcDate(utcOffset || 0);
  const day = format(date, 'DD', { locale: locales[lang] });
  const month = format(date, 'MMMM', { locale: locales[lang] });
  const year = format(date, 'YYYY', { locale: locales[lang] });
  const parsedDate =
    `
      <div class="info-item__top">
        <span class="day info-item__main">${day}</span>
        <span class="month info-item__sub">${month}</span>
      </div>
      <div class="info-item__bot">
        <p>${year}</p>
      </div>
    `;
  $(dateElement).html(parsedDate);
  setTimeout(() => showDate(dateElement), 20000);
}

export function showTime(timeElement) {
  if (!timeElement) return;
  // const date = new Date();
  const { utcOffset } = timeElement.dataset;
  const date = calcDate(utcOffset || 0);
  let h = date.getHours(); // 0 - 23
  let m = date.getMinutes(); // 0 - 59
  let session = 'AM';

  if (h === 0) {
    h = 12;
  }

  if (h > 12) {
    h -= 12;
    session = 'PM';
  }

  h = (h < 10) ? `0${h}` : h;
  m = (m < 10) ? `0${m}` : m;

  const time =
    `
      <span class="hours info-item__main">${h}</span>
      <span class="minutes info-item__main">${m}</span> 
      <span class="session info-item__sub">${session}</span>
    `;
  $(timeElement).html(time);

  setTimeout(() => showTime(timeElement), 20000);
}



// WEBPACK FOOTER //
// ./scripts/elements/clock.js